const sideBarStyle = {
  menuItem: {
    fontSize: 14,
  },
  width: '220px',
};

export default sideBarStyle;
